"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRANSLATE_PRIORITIES = exports.TICKET_STATUS_PLACEMENT = exports.PRIORITIES = exports.COLORS_BY_PRIORITY = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var PRIORITIES = exports.PRIORITIES = {
  LOW: 'low',
  NORMAL: 'normal',
  MEDIUM: 'medium',
  HIGH: 'high',
  CRITICAL: 'critical'
};
var TRANSLATE_PRIORITIES = exports.TRANSLATE_PRIORITIES = (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, PRIORITIES.LOW, 'низкий'), PRIORITIES.NORMAL, 'нормальный'), PRIORITIES.MEDIUM, 'средний'), PRIORITIES.HIGH, 'высокий'), PRIORITIES.CRITICAL, 'критический');
var COLORS_BY_PRIORITY = exports.COLORS_BY_PRIORITY = (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, PRIORITIES.LOW, '#00ae46'), PRIORITIES.NORMAL, '#dada0c'), PRIORITIES.MEDIUM, '#e6aa03'), PRIORITIES.HIGH, '#d0021b'), PRIORITIES.CRITICAL, '#d0021b');
var TICKET_STATUS_PLACEMENT = exports.TICKET_STATUS_PLACEMENT = {
  TICKET_CARD: 'ticket_card',
  // в карточке тикета
  TICKET_STATUS_SELECTOR: 'ticket_status_selector',
  // в селекторе статуса в редакторе тикета
  FILTERS: 'filters',
  // в фильтрах
  TICKET_CARD_WITH_MANAGER: 'ticket_card_with_manager' // в карточке тикета с менеджером
};